import React, { ReactNode, useContext } from "react"
import { DropdownContext } from "./Dropdown"
import s from "./Dropdown.less"

interface iProps {
  children: ReactNode
  className?: string
}

const DropdownActivator: React.FC<iProps> = ({ children, className }) => {
  const { toggleDropdown, isOpen } = useContext(DropdownContext)
  return (
    <div
      className={`${className ? ` ${className}` : isOpen ? s.active : ""}`}
      onClick={() => {
        toggleDropdown()
      }}
    >
      {children}
    </div>
  )
}

export default DropdownActivator
